
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initGoogleAdsTracking } from '@/utils/googleAds'

createRoot(document.getElementById("root")!).render(<App />);

// Defer Google Ads init to after render
if ('requestIdleCallback' in window) {
  (window as any).requestIdleCallback(() => { initGoogleAdsTracking(); });
} else {
  setTimeout(() => { initGoogleAdsTracking(); }, 2000);
}
